module.exports = __webpack_public_path__ + "static/media/facebook.cba4b3f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/facebook.svg
// module id = 312
// module chunks = 0